import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  condition: {
    userNo: 0,
    page: 1,
    limit: 10,
    storeNo: '',
    requestStatus:null,
    searchText: '',
    regDate: '',
    startDate: '',
    endDate: ''
  },
  detail: {
    bizRequestNo:'',
    storeNo:'',
    depositor:'',
    requestAmount:'',
    acceptAmount:'',
    status:'',
    requestDate:'',
    checkedDate:'',
    completedDate:'',
    cancelledDate:'',
    cancelledReason:'',
    storeName:'',
    chargedAmount:'',
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
